/**
 * Compares two values for sorting purposes.
 *
 * @param {string | number} a - The first value to compare.
 * @param {string | number} b - The second value to compare.
 * @param {boolean} isAsc - Whether the sort order is ascending (`true`) or descending (`false`).
 * @returns {number} - Returns -1 if `a` should come before `b`, 1 if `a` should come after `b`, based on the sort order.
 */
export function sortCompare(a: string | number, b: string | number, isAsc: boolean): number {
	return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
